import React from 'react'
import './inputs.css'

const BaseInput = ({ text, callback }) => {
    
    return (
        <div className='base-input-container'>
            <label className='base-input-label'>{text}</label>
            <input className='base-input' onChange={callback} />
        </div>
    )

}

export {
    BaseInput
}